/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */
import Tool from './Tool'
//
export default class PenFillTool extends Tool {
  marker
  options = { feature: { color: 'red', fillOpacity: .5, weight: 1 } }
  /**
   * 启动
   */
  start() {
    this.onMouseDown = this.onMouseDown.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    let { map } = this;
    map.on('mousedown', this.onMouseDown);
    //
    this.restart = true;

  }
  /**
   * 取消
   */
  cancel() {
    let { map } = this;
    map.off('mousedown', this.onMouseDown);
    map.off('mousemove', this.onMouseMove);
  }
  /**
   * 绘制
   */
  onMouseDown(e) {
    this.reset();
    //
    let { marker, options, map, layer } = this;
    let { latlng } = e;
    //
    if (!marker) {
      marker = this.marker = L.rectangle(L.latLngBounds(latlng, latlng), options.feature).addTo(layer)
      map.on('mousemove', this.onMouseMove);
      map.once('mouseup', this.onEnd.bind(this));
      // map.off('mousedown', this.onMouseDown);
    }
  }
  /**
   * 
   * @param e 
   */
  onMouseMove(e) {
    this.marker.addLatLng(e.latlng)
  }
}


// WEBPACK FOOTER //
// ./src/plugins/tools/PenFillTool.js